// Acción de carga obtener traslado servicio 
export const TRASLADO_SERVICIO_SUCCESS = 'TRASLADO_SERVICIO_SUCCESS';
export const TRASLADO_SERVICIO_FAIL = 'TRASLADO_SERVICIO_FAIL';
export const TRASLADO_SERVICIO_REQUEST = 'TRASLADO_SERVICIO_REQUEST';

// Acción de carga obtener establecimiento
export const ESTABLECIMIENTO_SUCCESS = 'ESTABLECIMIENTO_SUCCESS';
export const ESTABLECIMIENTO_FAIL = 'ESTABLECIMIENTO_FAIL';
export const ESTABLECIMIENTO_REQUEST = 'ESTABLECIMIENTO_REQUEST';

// Acción de carga obtener especie
export const TRASLADO_ESPECIE_SUCCESS = 'TRASLADO_ESPECIE_SUCCESS';
export const TRASLADO_ESPECIE_FAIL = 'TRASLADO_ESPECIE_FAIL';
export const TRASLADO_ESPECIE_REQUEST = 'TRASLADO_ESPECIE_REQUEST';

// Acción de carga obtener dependencia origen
export const COMBO_DEPENDENCIA_T_ORIGEN_REQUEST = 'COMBO_DEPENDENCIA_T_ORIGEN_REQUEST';
export const COMBO_DEPENDENCIA_T_ORIGEN_SUCCESS = 'COMBO_DEPENDENCIA_T_ORIGEN_SUCCESS';
export const COMBO_DEPENDENCIA_T_ORIGEN_FAIL = 'COMBO_DEPENDENCIA_T_ORIGEN_FAIL';

// Acción de carga obtener dependencia destino
export const COMBO_DEPENDENCIA_DESTINO_REQUEST = 'COMBO_DEPENDENCIA_DESTINO_REQUEST';
export const COMBO_DEPENDENCIA_DESTINO_SUCCESS = 'COMBO_DEPENDENCIA_DESTINO_SUCCESS';
export const COMBO_DEPENDENCIA_DESTINO_FAIL = 'COMBO_DEPENDENCIA_DESTINO_FAIL';

// Acción de carga Listado de traslados 
export const LISTA_TRASLADOS_REQUEST = 'LISTA_TRASLADOS_REQUEST';
export const LISTA_TRASLADOS_SUCCESS = 'LISTA_TRASLADOS_SUCCESS';
export const LISTA_TRASLADOS_FAIL = 'LISTA_TRASLADOS_FAIL';

// Acción de carga Listado de traslados con filtro para exportar a pdf
export const FILTRO_LISTA_TRASLADOS_REQUEST = 'FILTRO_LISTA_TRASLADOS_REQUEST';
export const FILTRO_LISTA_TRASLADOS_SUCCESS = 'FILTRO_LISTA_TRASLADOS_SUCCESS';
export const FILTRO_LISTA_TRASLADOS_FAIL = 'FILTRO_LISTA_TRASLADOS_FAIL';

// Acción de registra formulario traslados 
export const POST_FORMULARIO_TRASLADO_REQUEST = 'POST_FORMULARIO_TRASLADO_REQUEST';
export const POST_FORMULARIO_TRASLADO_SUCCESS = 'POST_FORMULARIO_TRASLADO_SUCCESS';
export const POST_FORMULARIO_TRASLADO_FAIL = 'POST_FORMULARIO_TRASLADO_FAIL';


// Acción de obtiene formulario inventario traslados 
export const OBTIENE_INV_TRASLADOS_REQUEST = 'OBTIENE_INV_TRASLADOS_REQUEST';
export const OBTIENE_INV_TRASLADOS_SUCCESS = 'OBTIENE_INV_TRASLADOS_SUCCESS';
export const OBTIENE_INV_TRASLADOS_FAIL = 'OBTIENE_INV_TRASLADOS_FAIL';

// Acción de obtiene archivos adjuntos
export const LISTA_TRASLADOS_ADJUNTOS_REQUEST = 'LISTA_TRASLADOS_ADJUNTOS_REQUEST';
export const LISTA_TRASLADOS_ADJUNTOS_SUCCESS = 'LISTA_TRASLADOS_ADJUNTOS_SUCCESS';
export const LISTA_TRASLADOS_ADJUNTOS_FAIL = 'LISTA_TRASLADOS_ADJUNTOS_FAIL';
